<template>
   <results-wrapper>
      <el-tabs>
         <el-tab-pane label="MHP Overview">
            <div class="bat-result-scenario" >
               <result-card
                  class="card"
                  v-for="([title, infos], index) in Object.entries(results)"
                  :key="index"
                  :title="title"
                  :infos="infos"
               />
            </div>
            <div class='powerhouse-wrapper'>
               <div class="title">MHP Information</div>
               <el-table :data="tableData" style="width: 100%">
                  <el-table-column
                     v-for="({prop, label, width, formatter}) in tableColumns"
                     :key="prop"
                     :prop="prop"
                     :formatter="formatter"
                     :label="label"
                     :width="width"
                  />
               </el-table>
            </div>
         </el-tab-pane>
      </el-tabs>
   </results-wrapper>
</template>

<script>
import { Tabs,TabPane,Table, TableColumn } from 'element-ui';
import ResultsWrapper from '../../../molecules/Home/ResultsWrapper';
import { mapGetters } from 'vuex';
import ResultCard from '../../../organisms/Home/ResultCard';


export default {
   components: {
      'el-tabs': Tabs,
      'el-tab-pane': TabPane,
      'el-table': Table,
      'el-table-column': TableColumn,
      ResultCard,
      ResultsWrapper,
   },
   data() 
   {
      const meterFormater = (r,c,value) => `${parseFloat(value)} m`
      const powerFormater = (r,c,value) => `${parseFloat(value)} kW`
      return {
         tableColumns: [
            { prop: "index", label:"SN.", width: 50 },
            { prop: "power_kW", label: "Power (kW)", formatter: powerFormater },
            { prop: "head_m", label: "Head (m)", formatter: meterFormater},
            { prop: "chainage_m", label: "Chainage (m)", formatter: meterFormater},
            { prop: "aoi_radius_m", label: "AOI Radius (m)", formatter: meterFormater},
            { prop: "num_household_required", label: "Household Required", width: 100},
            { prop: "num_household_calculated", label: "Household Achieved", width: 100},
            { prop: "latitude", label: "Latitude", },
            { prop: "longitude", label: "Longitude", },
            { prop: "elevation_m", label: "Elevation (m)", formatter: meterFormater},
         ],
      };
   },
   computed: {
      ...mapGetters(["getMhpResults"]),
      results()
      {
         const project =  this.getMhpResults.serialized_project;
         return {
            "Location information": {
               "State": project.municipality.state,
               "District": project.municipality.district,
               "Municipality": project.municipality.name,
               "Local Name": project.local_name,
               "Project Name": project.name,
            },
            "Intake Information": {
               "Latitude": `${project.intake_pt.x}°`,
               "Longitude": `${project.intake_pt.y}°`,
               "Elevation (m)": `${project.intake_pt.z} m`,
               "Discharge": `${parseFloat(project.discharge)} m3/s`,
               "Total Power Required (kW)": `${project.power_kW} kW`,
            },
         };
      },
      tableData()
      {
         return this.getMhpResults.powerhouses;
      },
   },
};
</script>

<style lang="scss">
.card {
   font-size: 0.98em;
}

.powerhouse-wrapper {
   border-radius: 0.25em;
   width: 100%;
   background: white;
   margin: 0.5em;
   * {
      color: $font-color;
   }
   // .el-table_1_column_2 
   > .title {
      font-size: 0.93em;
      padding: 0.6em 1em;
      border-radius: 0.25em 0.25em 0 0;
      color: $font-color;
      border-bottom: solid 1px rgba($primary-color, 0.1);
   }
}
</style>